import { atom } from 'recoil';

import { IProfile } from './types';

export const PROFILE = 'profile';

export const AProfile = atom<IProfile>({
  key: PROFILE,
  default: {
    isIncognitoMode: false,
  },
});
